<template>
  <div>
    <Modal
      :width="500"
      :value="modalOpen"
      :title="modalData.title"
      :subtitle="modalData.subtitle"
      :cta-text="modalData.ctaText"
      :cancel-hidden="modalData.cancelHidden"
      @cancel="modalOpen = false"
      dialogIcon="danger"
      @confirm="confirmModal">
    </Modal>

    <ul class="tree" v-if="messageTree.length > 0">
      <LiveChatTreeNode
        @openModal="openModal"
        @recomputeLastMessageMap="computeLastMessageMap"
        :node.sync="messageTree[0]"
        :parent="null"
        :lastMessageMap="lastMessageMap"></LiveChatTreeNode>
    </ul>
  </div>
</template>

<script>
  import LiveChatTreeNode from "./LiveChatTreeNode.vue";
  import Modal from "@/components/custom/Modal.vue";
  import cloneDeep from "lodash/cloneDeep";

  export default {
    components: { LiveChatTreeNode, Modal },
    props: {
      messageTree: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        modalOpen: false,
        modalData: {},
        styleElement: null,
        lastMessageMap: {},
      };
    },
    computed: {
      tinymceCss() {
        return this.$store.state.tinymceCss;
      },
    },
    watch: {
      tinymceCss: {
        immediate: true,
        handler(newCss) {
          this.updateStyles(newCss);
        },
      },
      messageTree: {
        deep: true,
        immediate: true,
        handler() {
          this.computeLastMessageMap();
        },
      },
    },
    beforeDestroy() {
      if (this.styleElement) {
        this.styleElement.remove();
        this.styleElement = null;
      }
    },
    methods: {
      updateStyles(css) {
        if (!this.styleElement) {
          this.styleElement = document.createElement("style");
          document.head.appendChild(this.styleElement);
        }

        this.styleElement.innerHTML = this.scopeCss(css, ".content-preview");
      },
      scopeCss(css, scopeSelector) {
        return css.replace(/(^|\})\s*([^\{]+)/g, (match, closingBracket, selectors) => {
          if (closingBracket) {
            return `${closingBracket} ${selectors
              .split(",")
              .map(sel => `${scopeSelector} ${sel.trim()}`)
              .join(",")}`;
          }

          return `${scopeSelector} ${selectors}`;
        });
      },
      openModal(data) {
        this.modalOpen = true;
        this.modalData = data;
      },
      confirmModal() {
        this.modalOpen = false;
        if (this.modalData.delete) {
          const children = cloneDeep(this.modalData.parent.children);
          this.modalData.parent.children = [];

          this.$nextTick(() => {
            children.splice(this.modalData.index, 1);
            this.modalData.parent.children = children;
          });
        }
      },
      computeLastMessageMap() {
        const map = {};
        const roots = Array.isArray(this.messageTree) ? this.messageTree : [];

        const traverse = (node, lastMsgId) => {
          let currentLastMsgId = lastMsgId;
          if (node && node.messageType === "message" && node.id) {
            currentLastMsgId = node.id;
          }

          const hasChildren = Array.isArray(node?.children) && node.children.length > 0;
          if (hasChildren) {
            node.children.forEach(child => traverse(child, currentLastMsgId));
          } else if (currentLastMsgId) {
            map[currentLastMsgId] = true;
          }
        };

        roots.forEach(root => traverse(root, null));
        this.lastMessageMap = map;
      },
    },
  };
</script>

<style lang="scss">
  @import "@/@core/preset/preset/shortcodes.scss";
</style>
